module.exports = __webpack_public_path__ + "img/UTFREM-9.40961565.jpg";